import { Controller } from "@hotwired/stimulus";

// Wash-flow diagram jumps: open the target's accordion, scroll to it, and flash a ring.
export default class extends Controller {
  static HIGHLIGHT = ["ring-2", "ring-ring", "ring-offset-2"];

  go(event) {
    if (event.type === "keydown" && event.key !== "Enter" && event.key !== " ") return;
    const target = document.getElementById(event.currentTarget.dataset.jumpTarget);
    if (!target) return;
    event.preventDefault();

    const content = target.closest("[data-accordion-id]");
    const toggler = content?.hidden && document.querySelector(`a[href="#${content.dataset.accordionId}"]`);
    if (toggler) toggler.click();
    setTimeout(() => this.reveal(target), toggler ? 350 : 0);
  }

  reveal(target) {
    target.scrollIntoView({ behavior: "smooth", block: "center" });
    target.classList.add(...this.constructor.HIGHLIGHT);
    setTimeout(() => target.classList.remove(...this.constructor.HIGHLIGHT), 1800);
  }
}
